// import HotelIcon from '../../stories/Icons/HotelIcon';
import {defaultTheme} from '@stencil/build-theme';

// import GoStaysIcon from '../../stories/Icons/GoStaysIcon';
import CoupleFriendlyIcon from '../../stories/Icons/CoupleFriendlyIcon';
import FlameIcon from '../../stories/Icons/FlameIcon';
import GiftTagIcon from '../../stories/Icons/GiftTagIcon';
import LocationIcon from '../../stories/Icons/LocationIcon';
// import OyoRoomsIcon from '../../stories/Icons/OyoRoomsIcon';
// import RoundedCheckbox from '../../stories/Icons/RoundedCheckbox';
import OfferIcon from '../../stories/Icons/OfferIcon';
import ShieldIcon from '../../stories/Icons/ShieldIcon';
import UgcPersuasionIcon from '../../stories/Icons/UgcPersuasionIcon';
// import HotelIcon from '../../stories/Icons/HotelIcon';
import SocialIcon from '../../stories/Icons/SocialIcon';
import FreeCancellationIcon from '../../stories/Icons/Amenities/FreeCancellationIcon';
import FreeBreakfast from '../../stories/Icons/Amenities/FreeBreakfast';
import SwimmingIcon from '../../stories/Icons/Amenities/SwimmingIcon';
import GocashOfferIcon from '../../stories/Icons/GocashIconOffer';
import GoSafeSheildLogo from '../../stories/Icons/goSafeSheildLogo';

import DealIcon from '../../stories/Icons/DealIcon';
import ThunderIcon from '../../stories/Icons/ThunderIcon';

import HappyGoCashPlusIcon from '@stencil/icons/src/HappyGoCashPlusIcon/HappyGoCashPlusIcon';
import HappyOfferIcon from '@stencil/icons/src/HappyOfferIcon/HappyOfferIcon';
import HappyBedPlusIcon from '@stencil/icons/src/HappyBedPlusIcon/HappyBedPlusIcon';
import HappyStarRemarkIcon from '@stencil/icons/src/HappyStarRemarkIcon/HappyStarRemarkIcon';
import HappyDoubleBedIcon from '@stencil/icons/src/HappyDoubleBedIcon/HappyDoubleBedIcon';

const HermesIconSelector = ({name, styleProps}: {name: string; styleProps: object}) => {
  // if (!name)
  //   return (
  //     <HotelIcon
  //       fill={defaultTheme.colors.downriver.medium}
  //       height="1.5rem"
  //       width="1.5rem"
  //       {...styleProps}
  //     />
  //   );

  switch (name) {
    // case 'tGostay':
    //   return <GoStaysIcon {...styleProps} />;
    case 'tCoupleFriendly':
      return <CoupleFriendlyIcon {...styleProps} />;

    // case 'tOyo':
    //   return <OyoRoomsIcon {...styleProps} />;
    case 'tDiscount':
      return <OfferIcon {...styleProps} />;
    case 'tCoin':
      return <OfferIcon {...styleProps} />;
    case 'tGoibibo':
      return <HappyGoCashPlusIcon {...styleProps} />;
    case 'tPercent':
      return <HappyOfferIcon {...styleProps} />;
    case 'tStealDeal':
      return <OfferIcon {...styleProps} />;
    case 'tVoyagerPer':
      return <UgcPersuasionIcon {...styleProps} />;
    case 'tCancel':
      return <ShieldIcon {...styleProps} />;
    case 'tFreeCancel':
      return <ShieldIcon {...styleProps} />;
    case 'tShieldIcon':
      return <ShieldIcon {...styleProps} />;
    case 'tLocation':
      return <LocationIcon {...styleProps} />;
    case 'tFlame':
      return <FlameIcon {...styleProps} />;
    case 'tFreeCancel':
      return <FreeCancellationIcon {...styleProps} />;
    case 'tFreeBrkFast':
      return <FreeBreakfast {...styleProps} />;
    case 'tBreakfast':
      return <FreeBreakfast {...styleProps} />;
    case 'tSocial':
      return <SocialIcon {...styleProps} />;
    case 'Swimming':
      return <SwimmingIcon {...styleProps} />;
    case 'tGosafe':
      return <GoSafeSheildLogo {...styleProps} />;
    case 'tDealTag':
      return <DealIcon {...styleProps} />;
    case 'tThunder':
      return <ThunderIcon {...styleProps} />;
    case 'tBed':
      return <HappyBedPlusIcon {...styleProps} height="1.4rem" width="1.4rem" />;
    case 'tStar':
      return <HappyStarRemarkIcon {...styleProps} height="2rem" width="2rem" />;
    case 'tExBed':
      return <HappyDoubleBedIcon {...styleProps} />;

    // case 'taHotels':
    //   return (
    //     <HotelIcon
    //       fill={defaultTheme.colors.downriver.medium}
    //       height="1.5rem"
    //       width="1.5rem"
    //       {...styleProps}
    //     />
    //   );
    default:
      return (
        <GiftTagIcon
          fill={defaultTheme.colors.downriver.medium}
          height="1.5rem"
          width="1.5rem"
          {...styleProps}
        />
      );
  }
};

export default HermesIconSelector;
